export default __webpack_public_path__ + "static/arrow-rainbow-c458670f92bda8a2198baf270a377648.gif";